import type { TVideoToken } from 'views/types/token';
import { create, useStore } from 'zustand';

interface IVideoTokensStore {
  tokens: TVideoToken[];
  totalTokens: number;
  totalPages: number;
  totalItems: number;
}

export const videoTokensStore = create<IVideoTokensStore>((_set) => ({
  tokens: [],
  totalTokens: 0,
  totalPages: 0,
  totalItems: 0,
}));

export const useVideoTokensStore = () => useStore(videoTokensStore);
